module.exports = __webpack_public_path__ + "88b9085464ab4a2401d721d330e513a3.png";